import { Injectable } from '@angular/core';

import {formatDate} from '@angular/common';
import { environment } from '../../../environments/environment';
import { FormControl,FormGroup } from '@angular/forms';
import { Subject }    from 'rxjs';



import { parsePhoneNumberFromString } from 'libphonenumber-js'

@Injectable({
  providedIn: 'root'
})
export class OthersService {

  private apiurl = '';
  private tokenkey = "_authtoken";
  private userkey = "_zerome";
  private devComp:any
  CurrentStaff:any = new Subject<object>();
  currentCompany:any = new Subject<object>();
  currentComp:any = new Subject<object>();
  private staff:any;
  private company:any;

  currentStaff$ = this.CurrentStaff.asObservable();

  currentCompany$ = this.currentCompany.asObservable();

  currentComp$ = this.currentComp.asObservable();


  constructor() { 
    this.apiurl = this.getApiUrl();
  }

  getApiUrl() {
      return  environment.apiUrl;
  }


  getCountries() {

    return environment.onlyCountries;

    //return this.httpservice.get(this.apiurl + '/v3/companines',{});
  }


  getAccessToken() {
    return sessionStorage.getItem(this.tokenkey); 
  }


  getCurrentUser() {
        
    //const userdata = localStorage.getItem(this.userkey);
    const userdata = sessionStorage.getItem(this.userkey);

    console.log('ERR: ' + userdata);
    //alert(userdata);

    if (userdata) {
        return JSON.parse(userdata);
    }

    return null;
  }

  setDefaultComp(data) {
      this.devComp = data;
  }

  getDefaultComp() {
     return this.devComp;
  }

  getCurrentStaff() {
    //console.log("dadasdasd return me:  " + JSON.stringify(this.CurrentStaff));
    return this.staff;
  }

  setCurrentStaff(staff:object) {
     //console.log("dadasdasd " + JSON.stringify(staff));
     this.CurrentStaff.next(staff);
     this.staff = staff;

  }

  getCurrentCompany() {
      return this.company;
  }

  getCountryCodeFromPhone(mobile) {
    const phoneNumber = parsePhoneNumberFromString('+'+mobile);
    if (phoneNumber) {
        let country = phoneNumber.country;
        return country;
    }
    return '';
  }


  setCurrentCompany(company:object) {
     this.currentCompany.next(company);
     this.company = company;
  }


  setCurrentComp(company:object) {
    this.currentComp.next(company);
  }

  setFormValue(form:FormGroup,input:string,value:string) {
      form.get(input).setValue(value);
  }


  parseYoutube(url:string) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;       
  }

  parseDate(datestring:string,format:string) {
      if (datestring) {
      let date = new Date(datestring);

      if (date) {
        //var newDate = new Date(date.getTime()-(date.getTimezoneOffset()*60*1000));

        return formatDate(date,format,'en');
      }
      }

      return datestring;
  }

  onFilter(str:string) {
    return str
    //.toLowerCase()
    .replace(/\w+/g, function(s) {
      return s[0].toUpperCase() + s.slice(1);
    });
  }  

  isMobile() {
    let isMobile = false; //initiate as false
// device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
        return true;
    }

    return false;
  }

  isiPhone() {
    if (/iPhone|iPod/.test(navigator.userAgent))  {
      return true;
    }

    return false;
  }

  randow2() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  randomWord(length:number) {
    var result           = '';
    var characters       = 'abcdefghijkmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  islightColor = (color:string) => {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
 }

 LightenDarkenColor(col:string,amt:number) {
  var usePound = false;
  if ( col[0] == "#" ) {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col,16);

  var r = (num >> 16) + amt;

  if ( r > 255 ) r = 255;
  else if  (r < 0) r = 0;

  var b = ((num >> 8) & 0x00FF) + amt;

  if ( b > 255 ) b = 255;
  else if  (b < 0) b = 0;
  
  var g = (num & 0x0000FF) + amt;

  if ( g > 255 ) g = 255;
  else if  ( g < 0 ) g = 0;

  return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}
}
